module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"noVacancies":"Вакансий пока нет"}}')
  delete Component.options._Ctor
}
